import React, { useEffect, useState } from "react";
import DataGridTable from "./table/DataGridTable";
import { Modal, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FadeLoader } from "react-spinners";
import moment from "moment-timezone";

const TaskCompletionReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { data } = location?.state;

  async function fetchCompletedTasks(taskDataId) {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/completed-task-report/${taskDataId}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);
      if (response.data.success) {
        return response.data.data;
      } else {
        console.error("Error fetching report:", response.data.message);
        return [];
      }
    } catch (error) {
      console.error("Failed to fetch completed tasks:", error);
      return [];
    }
  }

  useEffect(() => {
    if (data && data.id) {
      const loadTasks = async () => {
        const res = await fetchCompletedTasks(data.id);
        const rowsData = res.map((item, index) => ({
          ...item,
          attempt_date: moment(item.attempt_date)
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD HH:mm:ss"),
          indexID: index + 1,
        }));
        setTaskData(rowsData);
        setLoading(false);
      };
      loadTasks();
    }
  }, [data]);

  // Define table columns following your structure
  const columns = [
    { field: "indexID", headerName: "ID", width: 90 },
    {
      field: "employee_name",
      headerAlign: "left",
      align: "left",
      headerName: "Employee Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "customer_name",
      headerAlign: "left",
      align: "left",
      headerName: "Customer Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "task_name",
      headerAlign: "left",
      align: "left",
      headerName: "Task Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "outcome_status",
      headerAlign: "left",
      align: "left",
      headerName: "Outcome Status",
      minWidth: 200,
      flex: 2,
    },
    {
      field: "attempt_date",
      headerAlign: "left",
      align: "left",
      headerName: "Attempt Date",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "notes",
      headerAlign: "left",
      align: "left",
      headerName: "Notes",
      minWidth: 300,
      flex: 2,
    },
  ];

  // State for handling selected rows
  const [selectedRows, setSelectedRows] = useState([]);

  // Handle checkbox selection
  const handleSelectedRowsChange = (selectedRowIds) => {
    setSelectedRows(selectedRowIds);
    console.log("Selected Rows:", selectedRowIds);
  };

  // CSV Export Function
  const downloadCSV = () => {
    if (taskData.length === 0) return;

    const employeeName = taskData[0]?.employee_name || "Employee";
    const sanitizedEmployeeName = employeeName.replace(/[^a-zA-Z0-9_-]/g, "");

    // Define the filename
    const filename = `${sanitizedEmployeeName}_Task_Completion_Report.csv`;
    // Define CSV Headers
    const csvHeader =
      columns.map((col) => `"${col.headerName}"`).join(",") + "\r\n";

    // Format Data Rows
    const csvRows = taskData.map((row) =>
      columns.map((col) => `"${row[col.field] || ""}"`).join(",")
    );

    // Combine Headers and Data
    const csvContent = "\uFEFF" + csvHeader + csvRows.join("\r\n"); // UTF-8 BOM + Data

    // Create Blob and Download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="bg-white rounded">
        <div className="row m-0 py-1">
          <div className="col-6">
            <h5 className="m-0 font-bold text-lg text-gray-800 border-b-2 border-gray-300 pb-1">
              Task Report
            </h5>
          </div>
          <div className="col-6 d-flex align-items-end justify-content-end">
            <Button
              variant="btn btn-primary mx-1"
              style={{
                width: "100px",
                height: "35px",
                fontSize: "14px",
                borderRadius: "20px",
              }}
              onClick={downloadCSV}
            >
              Download
            </Button>
            <Button
              variant="btn btn-warning mx-1"
              style={{
                width: "70px",
                height: "35px",
                fontSize: "14px",
                borderRadius: "20px",
              }}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </div>
        </div>
        {loading ? (
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <FadeLoader size={10} color="#808b96" />
            <span
              style={{
                // marginTop: "10px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                color: "#808b96",
              }}
            >
              Preparing, please wait...
            </span>
          </div>
        ) : (
          <DataGridTable
            data={taskData}
            columns={columns}
            onCheckboxChange={handleSelectedRowsChange}
          />
        )}
      </div>
    </>
  );
};

export default TaskCompletionReport;
